const initialState = {
	metaData: {},
	linkedData: {},
	minTs: "",
	page: null,
}

const SettingMeta = (page, payload, staticMeta, statusCode) => {
	if (statusCode !== 200 || staticMeta === null) return { data: {}, page }
	let metaData = {}
	switch (page) {
		default:
			const fullPath = typeof payload.fullPath !== "undefined" ? payload.fullPath : staticMeta.fullPath || ""
			metaData = {
				title: staticMeta.title || "",
				fullPath,
				canonical: staticMeta.url || "",
				image: staticMeta.image || "",
				keywords: staticMeta.keywords || "",
				description: staticMeta.description || "",
				pageTitle: staticMeta.pageTitle || "",
				pageTitleColor: staticMeta.pageTitleColor || "",
				sectionName: staticMeta.sectionName || "",
			}
			return { data: metaData, page, statusCode }
	}
}

export default (state = initialState, action) => {
	switch (action.type) {
		case "RESET_STORE":
			return initialState
		case "SET_METATAG":
			return SettingMeta(action.page, action.payload, action.staticMeta, action.statusCode)
		default:
			return state
	}
}
